/**
 * OS ESTILOS DE DESENHO QUE A TELA OFERECE — T22 (12/10/2026).
 *
 * Na letra do operador (0049 T3.1): *"libere poder ter varios estilos na plataforma de modo geral.
 * Varias tags que rodam dessas forma"*. As tags são as de `backend-hq-lab/src/prompt-master/estilos.ts`;
 * uma tag que o servidor não conhece cai no estilo da casa, então a lista daqui nunca quebra nada.
 */
export const ESTILO_DA_CASA = "casa";

export const ESTILOS_DA_TELA: { tag: string; rotulo: string }[] = [
  { tag: ESTILO_DA_CASA, rotulo: "Massinha 3D (o padrão)" },
  { tag: "quadrinho", rotulo: "Quadrinho" },
  { tag: "aquarela", rotulo: "Aquarela" },
  { tag: "lapis-de-cor", rotulo: "Lápis de cor" },
  { tag: "manga", rotulo: "Mangá" },
];

/** O que vai para o servidor: nada quando é o da casa, para o pedido continuar igual ao de sempre. */
export function estiloParaEnviar(tag: string): string | undefined {
  return tag && tag !== ESTILO_DA_CASA ? tag : undefined;
}
